var React = require('react');

function Hamburger2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M6 36V33H42V36H6ZM6 25.5V22.5H42V25.5H6ZM6 15V12H42V15H6Z","fill":"black"}));
}

Hamburger2.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Hamburger2;

Hamburger2.default = Hamburger2;
